/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {BoardAffiliationInformation} from './board-affiliation-information.model';
import {Service} from '../../../common/service.class';
import {UserModelService} from '../../../common/user-model.service';

@Injectable()
export class BoardAffiliationInformationService extends UserModelService<BoardAffiliationInformation> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'boardAffiliationInformation', BoardAffiliationInformation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/information/board-affiliation-information.service.ts